const notificationActions = {
  FETCH_NOTIFICATIONS: 'FETCH_NOTIFICATIONS',
  REFRESH_NOTIFICATIONS: 'REFRESH_NOTIFICATIONS',
  SHOW_NOTIFICATIONS: 'SHOW_NOTIFICATIONS',
  SHOW_NOTIFICATIONS_ERROR: 'SHOW_NOTIFICATIONS_ERROR',
  UPDATE_NOTIFICATIONS_FILTER: 'UPDATE_NOTIFICATIONS_FILTER',
  CLOSE_NOTIFICATIONS: 'CLOSE_NOTIFICATIONS',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
};

const notificationsIcons = {
  dataset: 'table',
};

export const notificationsIcon = (entity) => notificationsIcons[entity] || 'users';

export default notificationActions;
